import Vue from "vue";
import Router from "vue-router";
import Hotpaths from "@/views/Hotpaths.vue";
import CompareDeploys from "@/views/CompareDeploys.vue";
import AuthCallback from "@/views/AuthCallback";
import HotpathDrilldown from "@/views/HotpathDrilldown";
import Welcome from "@/views/Welcome";
import Settings from "@/views/Settings";

Vue.use(Router);

function checkAuth(to, from, next) {
  if (process.env.VUE_APP_DEMO) {
    next();
    return
  }
  if (Vue.prototype.$auth0.isAuthenticated()) {
    next();
    return
  }
  Vue.prototype.$auth0.login();
}

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "hotpaths",
      component: Hotpaths,
      beforeEnter: checkAuth,
      props: route => {
        if (route.query.id) {
          return {
            selectedId: parseInt(route.query.id, 10)
          };
        }

        return null;
      }
    },
    {
      path: "/authcallback",
      name: "AuthCallback",
      component: AuthCallback
    },
    {
      path: "/welcome",
      name: "Welcome",
      beforeEnter: checkAuth,
      component: Welcome
    },
    {
      path: "/compare",
      name: "CompareDeploys",
      beforeEnter: checkAuth,
      component: CompareDeploys,
      props: route => {
        if (
          !route.query.projectID ||
          !route.query.deployID ||
          route.query.selection < 0
        ) {
          return null;
        }

        return {
          projectID: parseInt(route.query.projectID, 10),
          deployID: parseInt(route.query.deployID, 10),
          selection: parseInt(route.query.selection, 10)
        };
      }
    },
    {
      path: "/hotpathdrilldown/",
      name: "HotpathDrilldown",
      component: HotpathDrilldown,
      beforeEnter: checkAuth,
      props: route => {
        return {
          name: route.query.name
        };
      }
    },

    {
      path: "/settings/",
      name: "Settings",
      component: Settings,
      beforeEnter: checkAuth
    }
  ]
});
